import Programs from "containers/Settings/Screens/Programs/Programs.index";
import AdminProfile from "containers/Settings/Screens/AdminProfile/AdminProfile.index";
import Communications from "containers/Settings/Screens/Communications/Communications.index";
import Miscellaneous from "containers/Settings/Screens/Miscellaneous/Miscellaneous.index";
import PricingScheduler from "containers/Settings/Screens/PricingScheduler/PricingScheduler.index";
import Locations from "containers/Settings/Screens/Locations/Locations.index";
import ServicesAndBoosts from "containers/Settings/Screens/ServicesAndBoosts/ServicesAndBoosts.index";
import ServiceType from "containers/Settings/Screens/ServiceType/ServiceType.index";
import Categories from "containers/Settings/Screens/Categories/Categories.index";
import Boosts from "containers/Settings/Screens/ServicesAndBoosts/Boosts.index";
import ShiftsSchedule from "containers/Settings/Screens/Locations/ShiftsSchedule";
import CreateEditShiftSchedule from "containers/Settings/Screens/Locations/CreateEditShiftSchedule";
import Quickbooks from "containers/Settings/Screens/Quickbooks/Quickbooks.index";
import Restrictions from "containers/Settings/Screens/Restrictions/Restrictions.index";
import FormsManagement from "containers/FormsManagement/FormsManagement.index";
import FormEditCreate from "containers/FormsManagement/components/FormDesigner";
import Shifts from "containers/Settings/Screens/Shifts/Shifts.index";
import Contraindictions from "containers/Settings/Screens/Contraindications/Containdications.index";
import ProductContraindications from "containers/Settings/Screens/ProductContraindications/ProductContraindications.index";
import Skills from "containers/Skills/Skills.index";
import Marketting from "containers/Settings/Screens/Marketting/Marketting.index";
import Giftcards from "containers/Settings/Screens/Giftcards/Giftcards.index";
import EarningPoints from "containers/Settings/Screens/EarningPoints/EarningPoints.index";
import PointsValuePolicy from "containers/Settings/Screens/PointsValuePolicy/PointsValuePolicy.index";
import PushNotifications from "containers/Settings/Screens/PushNotifications/PushNotifications.index";
import LoyaltyRewardCatalog from "containers/Settings/Screens/LoyaltyRewardCatalog/LoyaltyRewardCatalog.index";
import Deals from "containers/Settings/Screens/Deals/Deals.index";
//  using  goBackURL because history.goBack takes user out of site when back btn in setting layout is clicked on direct settings page visit

let settingRoutes = [
  {
    path: "/dashboard/settings/programs",
    goBackURL: "/dashboard/settings",
    name: "programSettings",
    component: Programs,
    exact: true,
    title: "Programs",
    text: "Manage and configure programs, memberships, voucher codes and referrals.",
  },
  {
    path: "/dashboard/settings/pricing",
    goBackURL: "/dashboard/settings",
    name: "pricingSchedulerSettings",
    component: PricingScheduler,
    exact: true,
    title: "Pricing",
    text: "Create pricing schedule and manage services and add-ons by location.",
  },
  {
    path: "/dashboard/settings/services-and-boosts",
    goBackURL: "/dashboard/settings",
    name: "servicesAndBoosts",
    component: ServicesAndBoosts,
    exact: true,
    title: "Services & Add-ons",
    text: "Create and configure services and add-ons.",
  },
  {
    path: "/dashboard/settings/boosts",
    goBackURL: "/dashboard/settings/services-and-boosts",
    name: "boosts",
    component: Boosts,
    showCard: false,
    exact: true,
    title: "Add-ons",
  },
  {
    path: "/dashboard/settings/service-types",
    goBackURL: "/dashboard/settings",
    name: "serviceTypes",
    component: ServiceType,
    exact: true,
    title: "Service Type",
    text: "View service types.",
  },
  {
    path: "/dashboard/settings/categories",
    goBackURL: "/dashboard/settings",
    name: "categories",
    component: Categories,
    exact: true,
    title: "Categories",
    text: "Manage and configure categories.",
  },
  {
    path: "/dashboard/settings/locations",
    goBackURL: "/dashboard/settings",
    name: "locationSettings",
    component: Locations,
    exact: true,
    title: "Locations",
    text: "Create, manage and configure locations and business hours.",
  },
  {
    path: "/dashboard/settings/shift-schedules",
    goBackURL: "/dashboard/settings/locations",
    name: "shiftSchedule",
    component: ShiftsSchedule,
    showCard: false,
    exact: true,
    title: "Manage Business Hours",
  },
  {
    path: "/dashboard/settings/shift-schedule/:id",
    goBackURL: "/dashboard/settings/shift-schedules",
    name: "createEditShiftSchedule",
    component: CreateEditShiftSchedule,
    showCard: false,
    exact: true,
    title: "Edit Schedule",
  },
  {
    path: "/dashboard/settings/shift-schedule",
    goBackURL: "/dashboard/settings/shift-schedules",
    name: "createEditShiftSchedule",
    component: CreateEditShiftSchedule,
    showCard: false,
    exact: true,
    title: "Create Schedule",
  },
  {
    path: "/dashboard/settings/forms-managment/edit/:id",
    name: "form-edit",
    component: FormEditCreate,
    showCard: false,
    title: "Edit Form",
    showHeaders: false,
  },
  {
    path: "/dashboard/settings/forms-managment",
    name: "formsManagment",
    component: FormsManagement,
    exact: true,
    title: "Forms Management",
    text: "Create and manage charts and consent forms.",
  },
 
  // {
  //   path: "/dashboard/settings/admin-profile",
  //   name: "adminProfileSettings",
  //   component: AdminProfile,
  //   exact: true,
  //   title: "Admin Profile",
  //   text: "lorem ipsum dolor sit amet, consectetur adip lorem ipsum dolor sit amet, consectetur adip lorem ipsum dolor sit amet, consectetur lorem ipsum dolor sit amet, consectetur adip adips",
  // },
  {
    path: "/dashboard/settings/misc",
    goBackURL: "/dashboard/settings",
    name: "miscellaneousSettings",
    component: Miscellaneous,
    exact: true,
    title: "Miscellaneous",
    text: "Administer shift availablility, cancellation policies and booking session timeout.",
  },
  {
    path: "/dashboard/settings/shifts",
    name: "shifts",
    component: Shifts,
    exact: true,
    title: "Shifts",
    text: "Create and manage shifts.",
  },
  {
    path: "/dashboard/settings/contraindications-rules",
    name: "contraindications-rules",
    component: ProductContraindications,
    exact: true,
    title: "Contraindication Rules",
    text: "Create and manage contraindication rules.",
  },
  {
    path: "/dashboard/settings/contraindications",
    name: "contraindications",
    component: Contraindictions,
    exact: true,
    title: "Contraindications",
    text: "Create and manage contraindications.",
  },
  {
    path: "/dashboard/settings/communication",
    goBackURL: "/dashboard/settings",
    name: "coomunicationsSettings",
    component: Communications,
    exact: true,
    title: "Communications",
    text: "Manage email and text triggers.",
  },
  {
    path: "/dashboard/settings/quikbooks",
    goBackURL: "/dashboard/settings",
    name: "quikbooksSettings",
    component: Quickbooks,
    exact: true,
    title: "Manage QuickBooks Online",
    text: "Manage QuickBooks.",
  },
  {
    path: "/dashboard/settings/restrictions",
    goBackURL: "/dashboard/settings",
    name: "ServicesAndBoostsRestrictions",
    component: Restrictions,
    exact: true,
    title: "Restrictions",
    text: "Create and manage restrictions.",
  },
  {
    path: "/dashboard/settings/skills",
    goBackURL: "/dashboard/settings",
    name: "Skills",
    component: Skills,
    exact: true,
    title: "Skills",
    text: "Create and manage skills.",
  },
  {
    path: "/dashboard/settings/marketing",
    goBackURL: "/dashboard/settings",
    name: "markettingSettings",
    component: Marketting,
    exact: true,
    title: "Marketing",
    text: "Will add list of items to display in the 'How did you hear from us?'.",
  },
  {
    path: "/dashboard/settings/giftcards",
    goBackURL: "/dashboard/settings",
    name: "giftcardsManagement",
    component: Giftcards,
    exact: true,
    title: "Gift Cards Management",
    text: "Manage gift cards."
  },
  {
    path: "/dashboard/settings/earning-points",
    goBackURL: "/dashboard/settings",
    name: "earningPoints",
    component: EarningPoints,
    exact: true,
    title: "Earning Points",
    text: "Manage earning points."
  },
  {
    path: '/dashboard/settings/points-value-policy',
    goBackURL: '/dashboard/settings',
    name: 'pointsValuePolicy',
    component: PointsValuePolicy,
    exact: true,
    title: 'Points Value Policy',
    text: 'Manage points value policy.',
    showCard: false
  },
  {
    path: "/dashboard/settings/push-notifications",
    goBackURL: "/dashboard/settings",
    name: "pushNotifications",
    component: PushNotifications,
    exact: true,
    title: "Push Notifications",
    text: "Send push notifications to mobile app users.",
  },
  {
    path: "/dashboard/settings/loyalty-reward-catalog",
    goBackURL: "/dashboard/settings",
    name: "loyaltyRewardCatalog",
    component: LoyaltyRewardCatalog,
    exact: true,
    title: "Rewards/Redemption",
    text: "Manage products redeemable with reward points.",
  },
  {
    path: "/dashboard/settings/deals",
    goBackURL: "/dashboard/settings",
    name: "deals",
    component: Deals,
    exact: true,
    title: "Deals",
    text: "Manage deals.",
  }

];

export default settingRoutes;
